import { render, staticRenderFns } from "./AutomaticMoveOrder.vue?vue&type=template&id=30c86743"
import script from "./AutomaticMoveOrder.vue?vue&type=script&lang=js"
export * from "./AutomaticMoveOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports